module.exports = __webpack_public_path__ + "img/text.c7e98a95.png";